import { MouseEvent } from 'react';
import styles from './MenuButton.module.scss';
import cx from 'classnames';

type Props = {
  className?: string;
  onClick(e: MouseEvent<HTMLElement>): void;
};

export const MenuButton = ({ className = '', onClick }: Props) => {
  return (
    <button className={cx(styles.container, className)} onClick={onClick}>
      <span className={styles.circle} />
      <span className={styles.circle} />
      <span className={styles.circle} />
    </button>
  );
};
